import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { ContactCard } from './components/ContactCard/ContactCard';
import { ContactSideView } from './components/ContactUsSideView/ContactUsSideView';
import { ContactOfficeView } from './components/ContactUsOfficeView/ContactUsOfficeView';
import { FindOffice } from './components/FindOffice';
import './ContactUs.scss';

import { ContactUsData } from './ContactUs.types';

const ContactUs = () => {
  const contactusRef = useRef(null);
  const [data, setData] = useState<ContactUsData>();
  const [showFindOffice, setShowFindOffice] = useState(false);
  const [addresses, setAddresses] = useState(null);
  const [subOfficeListCount, setSubOfficeListCount] = useState(0);

  useEffect(() => {
    const url = new URL(window.location.toString());
    if (url.searchParams.get('countryId') || url.searchParams.get('isFilter'))
      setShowFindOffice(true);
    // get data from backend
    const init = async () => {
      try {
        const dataset = contactusRef.current?.parentElement?.dataset;
        const data = JSON.parse(dataset.data);
        const addresses = data?.MainOffices ?? data?.SubOffices ?? {};
        const countMainOffices = Object.entries(data?.MainOffices ?? data?.SubOffices ?? {}).reduce(
          (count, [key, value]) => {
            const officeType = key.split('|')[1];
            if (officeType?.trim() === 'Main office' && Array.isArray(value)) {
              return count + value.length;
            }
            return count;
          },
          0
        );
        setSubOfficeListCount(countMainOffices);
        setAddresses(addresses);
        setData(data);
      } catch (e) {
        console.log(e);
      }
    };
    init();
  }, []);

  return (
    <div className='contactus c-contact-main-top' ref={contactusRef}>
      <div className='l-section l-section-100'>
        <div className='l-content l-page-center'>
          {!showFindOffice ? (
            <div className='c_contact_us_body'>
              <h1 className='c_contact_us_heading'>{data?.Page?.Title}</h1>
              <div className='c_cards_sideview_section c-cards-sideview-top'>
                <div className='c_cards_layout'>
                  {data &&
                    data.EnquiryTypeLinks.map((eType, index) => {
                      return (
                        !eType.HideEnquiry && (
                          <ContactCard
                            key={index}
                            title={eType.EnquiryTitle}
                            description={eType.EnquiryDescription}
                            buttonText={eType.EnquiryButtonText}
                            typeLink={eType.EnquiryTypeLink}
                            enqType={eType.EnquiryTypeName}
                          />
                        )
                      );
                    })}
                </div>
                <div className={classNames('c_side_view', {
                  'no-padding': subOfficeListCount > 2,
                })}>
                  {data && data.Page && (
                    <ContactSideView
                      subOfficeList={addresses}
                      showOffices={subOfficeListCount < 3}
                      onShowFindContactsBtnClick={() => {
                        setShowFindOffice(true);
                      }}
                      pageLabels={data.Page}
                    />
                  )}
                </div>

              </div>

              {data && subOfficeListCount > 2 && <div className="c_contact_us_offices-view-body">
                <ContactOfficeView
                  subOfficeList={addresses}
                  onShowFindContactsBtnClick={() => {
                    setShowFindOffice(true);
                  }}
                  pageLabels={data.Page}
                />
              </div>}
            </div>
          ) : (
            <FindOffice
              onBackClick={() => {
                setShowFindOffice(false);
              }}
              data={data}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
